import { render, staticRenderFns } from "./ToggleCallEffect.vue?vue&type=template&id=1b55c292&scoped=true&"
import script from "./ToggleCallEffect.vue?vue&type=script&lang=js&"
export * from "./ToggleCallEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55c292",
  null
  
)

export default component.exports